module.exports = "/_next/static/videos/mov2x-2077e27c0f1d4285139e7ba7061d3c7c.mp4";